import { QueryClient } from '@tanstack/react-query'
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      cacheTime: 1000 * 60 * 60 * 24,
      refetchOnWindowFocus: false
    }
  }
})

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'LEME_REACT_QUERY_CACHE',
  throttleTime: 0,
  serialize: (data) => JSON.stringify(data),
  deserialize: (data) => JSON.parse(data),
  retry: (err) => {
    console.error('Erro ao persistir cache:', err)
    return false
  }
})

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24,
  buster: '',
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      return query.state.status === 'success' && query.state.data !== undefined
    }
  },
  hydrationOptions: {
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 60
      }
    }
  }
})

export default queryClient
